export interface ViaCepResponse {
  cep?: string;
  logradouro?: string;
  complemento?: string;
  bairro?: string;
  localidade?: string;
  uf?: string;
  erro?: boolean | string;
}

export async function fetchAddressByCep(cep: string): Promise<{
  street: string;
  neighborhood: string;
  city: string;
  state: string;
  zipCode: string;
} | null> {
  const cleanCep = cep.replace(/\D/g, '');
  if (cleanCep.length !== 8) return null;

  try {
    const res = await fetch(`https://viacep.com.br/ws/${cleanCep}/json/`);
    if (res.ok) {
      const data: ViaCepResponse = await res.json();
      if (!data.erro) {
        return {
          street: data.logradouro || '',
          neighborhood: data.bairro || '',
          city: data.localidade || '',
          state: data.uf || '',
          zipCode: data.cep || `${cleanCep.slice(0, 5)}-${cleanCep.slice(5)}`
        };
      }
    }
  } catch {
    // Primary API failed or blocked, try fallback
  }

  try {
    const fallbackRes = await fetch(`https://brasilapi.com.br/api/cep/v1/${cleanCep}`);
    if (fallbackRes.ok) {
      const fallbackData = await fallbackRes.json();
      return {
        street: fallbackData.street || '',
        neighborhood: fallbackData.neighborhood || '',
        city: fallbackData.city || '',
        state: fallbackData.state || '',
        zipCode: `${cleanCep.slice(0, 5)}-${cleanCep.slice(5)}`
      };
    }
  } catch {
    // Fallback also failed or offline
  }

  return null;
}

export function formatCep(value: string): string {
  const digits = value.replace(/\D/g, '').slice(0, 8);
  if (digits.length > 5) {
    return `${digits.slice(0, 5)}-${digits.slice(5)}`;
  }
  return digits;
}
